import React, { useEffect, useState } from 'react';
import { decryptData, deleteBlogDetailById, GetBlogType, SaveBlogDetail } from '../../../_seivices';
import Layout from '../../shared/Layout';
import { Toaster, toast } from "react-hot-toast";
import DataTable from 'react-data-table-component';
import ReactQuill from 'react-quill';
import 'react-quill/dist/quill.snow.css';
import axiosIns, { API_URL } from '../../../_config';
import LoadingButton from '../../shared/LoadingButton';
import useAsyncSubmit from '../../shared/useAsyncSubmit';

const Blog = () => {
    const [isFormopen, setIsFormopen] = useState(false);
    const [isFormopen1, setIsFormopen1] = useState(false);
    const [loading, setLoading] = useState(false);
    const [blogData, setBlogData] = useState([]);
    const [blogId, setblogId] = useState(null);
    const [blogTypeData, setBlogTypeData] = useState(null);
    const [blogDescrption, setblogDescrption] = useState(null);
    const [currentPage, setCurrentPage] = useState(1);
    const [rowsPerPage, setRowsPerPage] = useState(10);
    const { isSubmitting, run: runSubmit } = useAsyncSubmit();
    
    const handleChange = (e) => {
        const { name, value, type, checked, files } = e.target;
        setFormData(prevState => ({
            ...prevState,
            [name]: type === 'checkbox' ? checked : (type === 'file' ? files[0] : value)
        }));
    };

    const fetchBlogDetailAll = async () => {
        try {
            const res = await axiosIns.get(API_URL.GetBlogDetailAll);
            // Get the encrypted header
            const encrypted = res?.data?.payload;

            if (!encrypted) {
                setBlogData([]);
                return;
            }

            // ✅ Decrypt
            const decrypted = decryptData(encrypted);

            // ✅ Validate
            if (decrypted?.isSuccess === 1 && Array.isArray(decrypted.data)) {
                setBlogData(decrypted.data);
            } else {
                setBlogData([]);
            }
        } catch (error) {
            setBlogData([]);
        } finally {
            setLoading(false);
        }
    }

    useEffect(() => {
        fetchGetBlogType();
        fetchBlogDetailAll();
    }, [])

    const handlePageChange = (page) => {
        setCurrentPage(page);
    };

    const handleRowsPerPageChange = (newRowsPerPage, page) => {
        setRowsPerPage(newRowsPerPage);
        setCurrentPage(page);
    };

    const onSave = async (e) => {
        e.preventDefault();
        await runSubmit(async () => {
            try {
                await SaveBlogDetail(formData);
                fetchBlogDetailAll();
                toast.success("Save Successfully");

            } catch (error) {
                toast.error("Please try again later.");
            }
            finally {
                setFormData({
                    blogTypeId: 0,
                    blogId: 0,
                    blogImage: null,
                    blogTitle: '',
                    blogDescrption: '',
                    blogDate: '',
                    file: null,
                    createdBy: 0,
                    isActive: true
                });
                setIsFormopen(false);
            }
        });
    };

    const onEdit = (item) => {
        setblogId(item?.blogId)
        setIsFormopen(true);
        setFormData({
            ...formData,
            blogTypeId: item?.blogTypeId,
            blogId: item?.blogId,
            blogDescrption: item?.blogDescrption,
            blogTitle: item?.blogTitle,
            file: null,
            isActive: item?.isActive
        })
    }

    const view = (item) => {

        setIsFormopen1(true);
        setblogDescrption(item.blogDescrption);
    }

    const handleReset = () => {
        setFormData({
            blogTypeId: 0,
            blogId: 0,
            blogImage: null,
            blogTitle: '',
            blogDescrption: '',
            blogDate: '',
            file: null,
            createdBy: 0,
            isActive: true
        });
    };
    const onDelete = async (id) => {
        const isConfirmed = window.confirm("Are you sure you want to delete this item?");

        if (!isConfirmed) {
            return;
        }
        const data = await deleteBlogDetailById(id);
        if (data.isSuccess === 1) {
            fetchBlogDetailAll();
            toast.success("Delete Successfully");
        }
    };

    // Handle the description input change
    const handleDescriptionChange = (value) => {
        setFormData(prev => ({
            ...prev,
            blogDescrption: value  // Update contactNo in formData
        }));


    };

    const [formData, setFormData] = useState({
        blogTypeId: 0,
        blogId: 0,
        blogImage: null,
        blogTitle: '',
        blogDescrption: '',
        blogDate: '',
        file: null,
        createdBy: 0,
        isActive: true
    });

    const fetchGetBlogType = async () => {
        try {
            const data = await GetBlogType();
            setBlogTypeData(data);
        } catch (error) {
            return null;
        }
    };

    const onOpen = () => {
        // setProductId(null)
        setFormData({
            blogTypeId: 0,
            blogId: 0,
            blogImage: null,
            blogTitle: '',
            blogDescrption: '',
            blogDate: '',
            file: null,
            createdBy: 0,
            isActive: true
        });
        setIsFormopen(true)
    }

    const columns = [
        {
            name: 'SN',
            selector: (row, index) => ((currentPage - 1) * rowsPerPage) + index + 1,
            width: '70px'
        },
        {
            name: 'Image',
            selector: row => row.blogImage ? <img src={`${row?.blogImage}`} alt="" width="50" /> : 'No Image',
            sortable: false,
            width: '100px'
        },
        {
            name: 'Blog Type',
            selector: row => row.blogTypeName,
            sortable: true,
            width: '300px'
        },
        {
            name: 'Blog Title',
            selector: row => row.blogTitle,
            sortable: true,
        },
        {
            name: 'Description',
            width: '100px',
            cell: row => (
                <>
                    <button onClick={() => view(row)}>
                        <svg
                            fill="#526484"
                            version="1.1"
                            id="Capa_1"
                            xmlns="http://www.w3.org/2000/svg"
                            xmlnsXlink="http://www.w3.org/1999/xlink"
                            width="32px"
                            height="32px"
                            viewBox="0 0 442.04 442.04"
                            xmlSpace="preserve"
                        >
                            <g>
                                <g>
                                    <path
                                        d="M221.02,341.304c-49.708,0-103.206-19.44-154.71-56.22C27.808,257.59,4.044,230.351,3.051,229.203
                                c-4.068-4.697-4.068-11.669,0-16.367c0.993-1.146,24.756-28.387,63.259-55.881c51.505-36.777,105.003-56.219,154.71-56.219
                                c49.708,0,103.207,19.441,154.71,56.219c38.502,27.494,62.266,54.734,63.259,55.881c4.068,4.697,4.068,11.669,0,16.367
                                c-0.993,1.146-24.756,28.387-63.259,55.881C324.227,321.863,270.729,341.304,221.02,341.304z M29.638,221.021
                                c9.61,9.799,27.747,27.03,51.694,44.071c32.83,23.361,83.714,51.212,139.688,51.212s106.859-27.851,139.688-51.212
                                c23.944-17.038,42.082-34.271,51.694-44.071c-9.609-9.799-27.747-27.03-51.694-44.071
                                c-32.829-23.362-83.714-51.212-139.688-51.212s-106.858,27.85-139.688,51.212C57.388,193.988,39.25,211.219,29.638,221.021z"
                                    />
                                </g>
                                <g>
                                    <path
                                        d="M221.02,298.521c-42.734,0-77.5-34.767-77.5-77.5c0-42.733,34.766-77.5,77.5-77.5c18.794,0,36.924,6.814,51.048,19.188
                                c5.193,4.549,5.715,12.446,1.166,17.639c-4.549,5.193-12.447,5.714-17.639,1.166c-9.564-8.379-21.844-12.993-34.576-12.993
                                c-28.949,0-52.5,23.552-52.5,52.5s23.551,52.5,52.5,52.5c28.95,0,52.5-23.552,52.5-52.5c0-6.903,5.597-12.5,12.5-12.5
                                s12.5,5.597,12.5,12.5C298.521,263.754,263.754,298.521,221.02,298.521z"
                                    />
                                </g>
                                <g>
                                    <path
                                        d="M221.02,246.021c-13.785,0-25-11.215-25-25s11.215-25,25-25c13.786,0,25,11.215,25,25S234.806,246.021,221.02,246.021z"
                                    />
                                </g>
                            </g>
                        </svg>

                    </button>

                </>
            )
            // selector: row => (
            //     <div className="word-wrap"  dangerouslySetInnerHTML={{ __html: row.blogDescrption }} />
            // ),
            // sortable: true
        },
        {
            name: 'Actions',
            width: '100px',
            cell: row => (
                <div className='d-flex gap-2'>
                    <button onClick={() => onEdit(row)} className='edit_icon_wepper'>
                        <svg id="Layer_1" viewBox="0 0 512 512" width="18" height="18" xmlns="http://www.w3.org/2000/svg">
                            <g transform="matrix(1,0,0,1,0,0)">
                                <path d="m41.3 512c-22.8 0-41.3-18.5-41.3-41.3 0-2.6.2-5.2.7-7.7l27.3-144.8c1.5-8.2 5.5-15.7 11.4-21.5l274-274c14.7-14.7 35.1-22.7 57.7-22.7 8.1 0 16.1 1 24 2.8 25.5 5.9 51.1 20.7 72.2 41.8s36 46.7 41.8 72.2c7.4 31.9.2 61.7-19.8 81.7l-274 274c-5.9 5.9-13.4 9.8-21.5 11.4l-144.8 27.4c-2.5.5-5.1.7-7.7.7zm51.8-93.1 72.9-13.8 182-182-59.1-59.1-182 182zm313.3-254.2 23.1-23.1c.2-5.4-3.8-21.8-20.6-38.5-10.1-10.2-22-17.4-32.4-19.8-1.8-.4-3.7-.7-5.5-.7h-.7l-23 23z" fill="#526484" />
                                <path d="m499.4 119.1c-5.4-23.7-19.4-47.6-39.1-67.4s-43.8-33.7-67.4-39.1c-28.5-6.6-54.9-.4-72.3 17.1l-274 274c-4.5 4.4-7.5 10.1-8.7 16.3l-27.4 144.9c-3.2 17 8 33.4 24.9 36.6 1.9.4 3.9.5 5.8.5s3.9-.2 5.8-.5l145-27.4c6.2-1.2 11.9-4.2 16.3-8.6l274-274c17.5-17.5 23.7-43.9 17.1-72.4zm-328.5 295.3-90.3 17 17-90.3 191.3-191.3 73.3 73.3zm267.2-267.2-31.7 31.7-73.2-73.3 31.7-31.7c1-1 5.6-2.3 14-.4 12.2 2.8 25.8 11 37.2 22.4 23.5 23.7 25.6 47.7 22 51.3z" fill="url(#gradient1)" />
                                <defs>
                                    <linearGradient id="gradient1" x1="0%" y1="0%" x2="100%" y2="100%">
                                        <stop offset="0%" stopColor="#526484" />
                                        <stop offset="100%" stopColor="#0063ff" />
                                    </linearGradient>
                                </defs>
                            </g>
                        </svg>
                    </button>
                    <button onClick={() => onDelete(row.blogId)} className='edit_icon_wepper'>
                        <svg xmlns="http://www.w3.org/2000/svg" x="0px" y="0px" width="20" height="20" viewBox="0 0 24 24">
                            <path d="M 10 2 L 9 3 L 4 3 L 4 5 L 5 5 L 5 20 C 5 20.522222 5.1913289 21.05461 5.5683594 21.431641 C 5.9453899 21.808671 6.4777778 22 7 22 L 17 22 C 17.522222 22 18.05461 21.808671 18.431641 21.431641 C 18.808671 21.05461 19 20.522222 19 20 L 19 5 L 20 5 L 20 3 L 15 3 L 14 2 L 10 2 z M 7 5 L 17 5 L 17 20 L 7 20 L 7 5 z M 9 7 L 9 18 L 11 18 L 11 7 L 9 7 z M 13 7 L 13 18 L 15 18 L 15 7 L 13 7 z" fill="#526484"></path>
                        </svg>
                    </button>
                </div>
            )
        }
    ];


    const modules = {
        toolbar: [
            [{ 'header': '1' }, { 'header': '2' }, { 'font': [] }],
            [{ 'list': 'ordered' }, { 'list': 'bullet' }],
            ['bold', 'italic', 'underline'],
            [{ 'align': [] }],
            ['link'],
            ['image']
        ],
    };

    return (


        <Layout>
            <div className="px-4">
                <div className="admin-page mt-3 d-sm-flex justify-content-between align-items-center">
                    <div className="admin-heading" style={{ gap: "20px" }}>
                        <h4 className="mb-0">Blog Post</h4>
                    </div>
                    <div className="add_btn">
                        <button onClick={onOpen}>Add New Blog</button>
                    </div>
                </div>
            </div>

            <div className="datatable mt-3">
                <DataTable
                    fixedHeader
                    fixedHeaderScrollHeight="calc(100vh - 220px)"
                    columns={columns}
                    data={blogData || []}
                    progressPending={loading}
                    progressComponent={<p>Loading...</p>}
                    pagination
                    paginationPerPage={rowsPerPage}
                    onChangePage={handlePageChange}
                    onChangeRowsPerPage={handleRowsPerPageChange}
                    highlightOnHover
                />
            </div>

            {isFormopen && <div className="backdrop" onClick={() => setIsFormopen(false)}></div>}
            <div id="entryformContainer" style={{ width: "800px" }} className={`adminform entryform ${isFormopen ? 'open' : ''}`}>
                <div className="closebtn">
                    <button className="" onClick={() => setIsFormopen(false)} >
                        <svg clipRule="evenodd" fillRule="evenodd" height="30" imageRendering="optimizeQuality" shapeRendering="geometricPrecision" textRendering="geometricPrecision" viewBox="0 0 6.82666 6.82666" width="30" xmlns="http://www.w3.org/2000/svg" version="1.1" xmlnsXlink="http://www.w3.org/1999/xlink" >
                            <g transform="matrix(1,0,0,1,0,0)">
                                <g id="Layer_x0020_1">
                                    <rect fill="#ffffff00" height="6.827" rx="1.507" width="6.827" stroke="none" />
                                    <path d="m2.21002 1.41333-.79669.79669 1.20331 1.20331-1.20331 1.20331.79669.79669 1.20331-1.20331 1.20332 1.20331.79668-.79669-1.2033-1.20331 1.2033-1.20331-.79669-.79669-1.20331 1.2033z" fill="#fffffe" stroke="none" />
                                </g>
                            </g>
                        </svg>
                    </button>
                </div>
                <div className="enForm">
                    <div className="text-center form-heading">
                        <h4>Add New Blog</h4>
                    </div>
                    <form onSubmit={onSave}>

                        <div className="form-group">
                            <label htmlFor="formFile">Blog Type</label>
                            <select id="blogTypeId" className="form-control" name="blogTypeId" value={formData.blogTypeId} onChange={handleChange}>
                                <option value="--Select--"  >--Select--
                                </option>
                                {blogTypeData?.map((item, i) => (
                                    <option key={i} value={item.blogTypeId}>{item.blogTypeName}
                                    </option>

                                ))}
                            </select>
                        </div>

                        <div className="form-group">
                            <label htmlFor="formFile">Title</label>
                            <input type="text" className="form-control" id="blogTitle" name="blogTitle" value={formData.blogTitle} onChange={handleChange} placeholder='Enter Blog Name' />
                        </div>
                        <div className="form-group">
                            <label htmlFor="formFile">Descriprion</label>
                            {/* <input type="text" className="form-control" id="blogDescrption" name="blogDescrption" value={formData.blogDescrption} onChange={handleChange} /> */}

                            <ReactQuill
                                value={formData.blogDescrption}
                                onChange={handleDescriptionChange}
                                modules={modules}
                                theme="snow"
                                placeholder="Enter blog description here"
                            />
                        </div>
                        <div className="form-group">
                            <label htmlFor="formFile">File {`(Size : 1076px * 628px)`}</label>
                            <input type="file" className="form-control" id="file" name="file" accept="image/png, image/jpeg" onChange={handleChange} />
                        </div>


                        <div className="d-flex form-buttons" style={{ gap: "15px" }}>
                            <div className="submit-btn pt-2">
                                <LoadingButton type="submit" loading={isSubmitting} loadingText={blogId ? 'Updating...' : 'Saving...'}>{blogId ? 'Update' : 'Submit'}</LoadingButton>
                            </div>
                            <div className="reset-btn pt-2">
                                <button type="button" onClick={handleReset}>Reset</button>
                            </div>
                        </div>
                    </form>
                </div>
            </div>

            <div id="entryformContainer" style={{ width: "800px" }} className={`adminform entryform ${isFormopen1 ? 'open' : ''}`}>
                <div className="closebtn">
                    <button className="" onClick={() => setIsFormopen1(false)} >
                        <svg clipRule="evenodd" fillRule="evenodd" height="30" imageRendering="optimizeQuality" shapeRendering="geometricPrecision" textRendering="geometricPrecision" viewBox="0 0 6.82666 6.82666" width="30" xmlns="http://www.w3.org/2000/svg" version="1.1" xmlnsXlink="http://www.w3.org/1999/xlink" >
                            <g transform="matrix(1,0,0,1,0,0)">
                                <g id="Layer_x0020_1">
                                    <rect fill="#ffffff00" height="6.827" rx="1.507" width="6.827" stroke="none" />
                                    <path d="m2.21002 1.41333-.79669.79669 1.20331 1.20331-1.20331 1.20331.79669.79669 1.20331-1.20331 1.20332 1.20331.79668-.79669-1.2033-1.20331 1.2033-1.20331-.79669-.79669-1.20331 1.2033z" fill="#fffffe" stroke="none" />
                                </g>
                            </g>
                        </svg>
                    </button>
                </div>
                <div className="enForm">
                    <div className="text-center form-heading">
                        <h4> Blog Descriprion</h4>
                    </div>
                    <div>
                        <p ><div className="word-wrap" dangerouslySetInnerHTML={{ __html: blogDescrption }} /></p>
                    </div>
                </div>
            </div>
            <Toaster position="top-right" />
        </Layout>
    );
};

export default Blog;

